export class TituloReceberVencidosTotal {
    quantidade: number;
    valor: number;

    dataInicial: Date;
    dataFinal: Date;
}
